import React from 'react';
import styled from 'styled-components';
import Icon from '@mdi/react'
import { mdiEmail, mdiFacebook, mdiInstagram } from '@mdi/js'
import Fade from 'react-reveal/Fade'

const Section = styled.div`
	padding-top: 4rem;
	background-color: #113f71;
	color: #fff;
	padding-bottom: 8rem;
`;

const Title = styled.h2`
	text-align: center;
	font-size: 24px;
	margin-bottom: 2rem;
`;

const SocialLinks = styled.ul`
	display: flex;
	align-items: center;
	justify-content: center;
	
	svg {
	    width: 30px;
	}
	
	li {
	    margin-right: 1rem;
	}
`;

const Contact = () => {
	return (
	    <Fade duration={500} up>
            <Section>
                <Title>Connect with Emanuel</Title>
                <SocialLinks>
                    <li><a href="mailto:schedulemyhealing@gmail.com" target="_blank" rel="noreferrer"><Icon path={mdiEmail} /></a></li>
                    <li><a href="https://www.facebook.com/compasshealings" target="_blank" rel="noreferrer"><Icon path={mdiFacebook} /></a></li>
                    <li><a href="https://www.instagram.com/EmanuelZevallos" target="_blank" rel="noreferrer"><Icon path={mdiInstagram} /></a></li>
                </SocialLinks>
            </Section>
        </Fade>
	)
}

export default Contact;
